import { useEffect, useState } from "react";
import { FaLink, FaChartBar, FaListUl, FaInbox } from "react-icons/fa";
import { fetchPrograms } from "../../redux/program/programActions";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Table from "../../components/Table/Table";
import Loader from "../../components/Loader/Loader";
import { tableConstants } from "./StudentSubjectMappingTableConst";
import { tableConstants as studentTableConstants } from "./StudentCountSubjectWiseTableConst";
import StudentSubjectFilter from "./StudentSubjectFilter";
import {
  getStudentSubjectMappingList,
  getStudentCountSubjectWise,
} from "../../services/StudentSubjectMappingService";
import { getClassWiseSubjects } from "../../services/SubjectServices";
import { enqueueSnackbar } from "notistack";
import "./StudentSubjectMapping.css";

const StudentSubjectMappingList = () => {
  const [data, setData] = useState([]);
  const [program_id, setProgramId] = useState("");
  const [subject_id, setSubjectId] = useState("");
  const [subjectList, setSubjectList] = useState([]);
  const [student_count, setStudentCount] = useState("1");
  const [loader, setLoader] = useState(false);
  const permissions = JSON.parse(localStorage.getItem("permissions"));
  const dispatch = useDispatch();
  const programData = useSelector((state) => state.program.programs.data);

  const fetchData = async () => {
    let session_id = localStorage.getItem("session_id");
    if (!program_id)
      enqueueSnackbar("Please select class", { variant: "error" });
    try {
      setLoader(true);
      setData([]);
      if (student_count === "1") {
        let response = await getStudentCountSubjectWise(program_id);
        if (response.status === 200) {
          setData(response.data.data);
        }
      } else {
        let response = await getStudentSubjectMappingList(
          session_id,
          program_id,
          subject_id
        );
        if (response.status === 200) {
          setData(response.data.data);
        }
      }
    } catch (error) {
    } finally {
      setLoader(false);
    }
  };

  const getSubjectList = async (programId) => {
    try {
      const res = await getClassWiseSubjects(programId);
      if (res.status !== 200) {
        return;
      }
      const subjectData = res.data.data;
      setSubjectList(subjectData);
    } catch (error) {
    }
  };

  const changeHandler = (e) => {
    const { name, value } = e.target;
    
    if (name === "program_id") {
      setProgramId(value);
      getSubjectList(e.target.value);
    }
    if (name === "subject_id") {
      setSubjectId(value);
    }
  };

  useEffect(() => {
    dispatch(fetchPrograms());
  }, [dispatch]);

  return (
    <div className="card">
      <div className="card-header">
        <div className="d-flex justify-content-between align-items-center">
          <div className="main-title-page page-title d-flex align-items-center">
            <span className="mx-2"><FaLink /></span>
            <span>Student Subject Mapping List</span>
          </div>
          <div className="">
            {permissions.includes("student.subject.mapping.update") && (
              <Link
                className="btn btn-secondary mx-2"
                to="/student/subject/mapping/update"
              >
                Update Mapping
              </Link>
            )}
            {permissions.includes("student.subject.mapping.create") && (
              <Link
                className="btn btn-success"
                to="/student/subject/mapping/create"
              >
                Add Mapping
              </Link>
            )}
          </div>
        </div>
      </div>
      <div className="card-body">
        <div className="ssm-toggle-group">
          <button
            type="button"
            className={`ssm-toggle-btn ${student_count === "1" ? "active" : ""}`}
            onClick={() => {
              setStudentCount("1");
              setData([]);
            }}
          >
            <FaChartBar /> Subject Wise Student Count
          </button>
          <button
            type="button"
            className={`ssm-toggle-btn ${student_count === "2" ? "active" : ""}`}
            onClick={() => {
              setStudentCount("2");
              setData([]);
            }}
          >
            <FaListUl /> Subject Wise Student List
          </button>
        </div>
        <div className="ssm-filter-bar">
          <StudentSubjectFilter
            student_count={student_count}
            programData={programData}
            program_id={program_id}
            subject_id={subject_id}
            subjectList={subjectList}
            changeHandler={changeHandler}
            fetchData={fetchData}
          />
        </div>
        <div className="">
          {loader ? (
            <Loader />
          ) : (
            <div className="evaluating-table mt-2">
              {data && data.length > 0 ? (
                student_count === "1" ? (
                  <Table
                    cols={studentTableConstants()}
                    data={data}
                    striped={true}
                    hoverable={true}
                  />
                ) : (
                  <Table
                    cols={tableConstants()}
                    data={data}
                    striped={true}
                    hoverable={true}
                  />
                )
              ) : (
                <div className="ssm-empty-state">
                  <FaInbox />
                  <span>No data found</span>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default StudentSubjectMappingList;
